import React from 'react';
import logo from '../assets/logo.png';

/** The Festival Systems logo. Its artwork is white on dark slate, so it shows as a rounded tile on any background */
const BrandLogo: React.FC<{ size: number }> = ({ size }) => (
  <img className="brand-logo" src={logo} width={size} height={size} alt="" />
);

export default BrandLogo;
